







import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CompPartsInfotext extends Vue {
  @Prop({ type: String, default: '' })
  readonly text!: string;

  @Prop({ type: Boolean, default: false })
  readonly padding!: boolean;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/infotext/Infotext.vue